import { render } from "./CreateAbandon.vue?vue&type=template&id=5a4596a4"
import script from "./CreateAbandon.vue?vue&type=script&lang=js"
export * from "./CreateAbandon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__